<template>
  <div class="foreigner-form-container">
    <Panel title="5. สำหรับชาวต่างชาติ">
      <div class="description-text">
        ท่านมีถิ่นที่อยู่ในประเทศไทยหรือไม่ (พำนักอยู่ในเประเทศไทยอย่างน้อย 180 วัน ต่อปี)
      </div>
      <div class="foreigner-residency-form">
        <div class="form-group">
          <div class="input-group">
            <div class="thailand-residency-radio-container">
              <Radio
                name="isHasThailandResidency"
                :label="true"
                v-model="isHasThailandResidency"
                :disabled="isDisabledApplicationForm"
              >
                ใช่
              </Radio>
            </div>
            <div class="thailand-residency-radio-container">
              <Radio
                name="isHasThailandResidency"
                :label="false"
                v-model="isHasThailandResidency"
                :disabled="isDisabledApplicationForm"
              >
                ไม่ใช่ ถ้าท่านตอบ "ไม่ใช่กรุณาระบุประเทศที่ท่านมีถิ่นที่อยู่"
              </Radio>
            </div>
          </div>
        </div>
        <Dropdown
          class="form-control input-sm"
          :class="{
            'bd-red': applicationValidationErrors.has('countryOfResidency'),
          }"
          :options="generateCountryOptions"
          v-model="countryOfResidency"
          :selectedValue="countryOfResidency"
          :disabled="isDisabledApplicationForm"
          v-if="!isHasThailandResidency && !_.isNull(isHasThailandResidency)"
        />
      </div>
      <p
        class="thailand-residency-error-text"
        v-if="applicationValidationErrors.has('isHasThailandResidency')"
      >
        * กรุณาเลือกการมีถิ่นที่อยู่ของท่าน
      </p>
    </Panel>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapActions, mapGetters } from 'vuex'
import { createHelpers } from 'vuex-map-fields'

import Dropdown from '@/components/Dropdown'
import Panel from '@/components/Panel'
import Radio from '@/components/Radio'

const { mapFields: mapApplicationFields } = createHelpers({
  getterType: 'getApplicationFields',
  mutationType: 'updateApplicationFields',
})

export default {
  name: 'ForeignerForm',
  watch: {
    isHasThailandResidency() {
      this.countryOfResidencyValidationRule = !this.isHasThailandResidency ? 'required' : ''
    },
  },
  computed: {
    ...mapGetters([
      'countryInformation',
      'applicationValidationErrors',
      'isDisabledApplicationForm',
    ]),
    ...mapApplicationFields({
      isHasThailandResidency: 'data.foreigner.isHasThailandResidency',
      countryOfResidency: 'data.foreigner.countryOfResidency',
      countryOfResidencyValidationRule: 'validation.rules.countryOfResidency',
    }),
    generateCountryOptions() {
      const defaultOptions = {
        value: '',
        description: 'โปรดระบุประเทศที่ท่านมีถิ่นที่อยู่',
      }

      const countryOptions = this.countryInformation.data.map(data => ({
        value: data.id,
        description: data.country_name_th,
      }))

      if (this.countryOfResidency) {
        return countryOptions
      }

      return [defaultOptions, ...countryOptions]
    },
  },
  components: {
    Dropdown,
    Panel,
    Radio,
  },
}
</script>

<style lang="scss">
.foreigner-form-container {
  .foreigner-residency-form {
    .thailand-residency-radio-container {
      display: inline-block;
      margin-right: 32px;
    }
  }

  .thailand-residency-error-text {
    color: #e40000;
    font-size: 12px;
    line-height: 16px;
  }
}
</style>
